import React, {Suspense, lazy} from 'react';
import {
  ROUTE_DR_RCPA_PLANNING_SUMMARY_REPORT,
} from '@app/navigations/RoutePathConstant';
import {authLoader} from '@app/navigations/loader';
import {Spin} from 'antd';

const DrRCPAPlanningSummaryReport = lazy(() =>
  import('../../../screens/DrRCPAPlanningSummaryReport')
    .then(module => ({default: module.DrRCPAPlanningSummaryReport})));

const DrRCPAPlanningSummaryReportNavigation = [
  {
    path: ROUTE_DR_RCPA_PLANNING_SUMMARY_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <DrRCPAPlanningSummaryReport />
      </Suspense>
    ),
  },
];

export default DrRCPAPlanningSummaryReportNavigation;
